module.exports = __webpack_public_path__ + "img/pos-y.e0d6712e.png";